import React from "react";
import { Col, Row, Card, Form } from '@themesberg/react-bootstrap';
import { useTranslation } from "react-i18next";
import { ChangePasswordForm } from "./ChangePasswordForm";
export const GeneralInfoForm = ({ formData, onChange, userType, setUserType, profileExists }) => {
  const { t } = useTranslation();

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">{t("profilePageTranslations.generalInfoTitle")}</h5>
        <Form>
          {/* User Type Selector */}
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label>{t("profilePageTranslations.accountTypeLabel")}</Form.Label>
                <Form.Select
                  value={userType}
                  onChange={(e) => setUserType(e.target.value)}
                  disabled={profileExists}
                >
                  <option value="private">{t("profilePageTranslations.accountTypePrivate")}</option>
                  <option value="company">{t("profilePageTranslations.accountTypeCompany")}</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* Full Name */}
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="fullName">
                <Form.Label>
                  {userType === "company"
                    ? t("profilePageTranslations.fullNameDirectorLabel")
                    : t("profilePageTranslations.fullNameLabel")}
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder={t("profilePageTranslations.fullNamePlaceholder")}
                  value={formData.fullName || ""}
                  onChange={(e) => onChange("fullName", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Company Name (only for company) */}
          {userType === "company" && (
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group id="companyName">
                  <Form.Label>{t("profilePageTranslations.companyNameLabel")}</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder={t("profilePageTranslations.companyNamePlaceholder")}
                    value={formData.companyName || ""}
                    onChange={(e) => onChange("companyName", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* Address */}
          <Row>


            <Col md={6} className="mb-3">
              <Form.Group id="street">
                <Form.Label>{t("profilePageTranslations.addressLabel")} </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter street"
                  value={formData.street || ""}
                  onChange={(e) => onChange("street", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group id="postalCity">
                <Form.Label>{t("profilePageTranslations.addressLabe2")}</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder={t("profilePageTranslations.addressLabe2")}
                  value={formData.postalCity || ""}
                  onChange={(e) => onChange("postalCity", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Row>
            </Row>

          </Row>

          {/* Email & Phone */}
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="email">
                <Form.Label>{t("profilePageTranslations.emailLabel")}</Form.Label>
                <Form.Control
                  required
                  type="email"
                  placeholder={t("profilePageTranslations.emailPlaceholder")}
                  value={formData.email || ""}
                  onChange={(e) => onChange("email", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="phone">
                <Form.Label>{t("profilePageTranslations.phoneLabel")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("profilePageTranslations.phonePlaceholder")}
                  value={formData.phone || ""}
                  onChange={(e) => onChange("phone", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Eligibility Checkbox (only for company) */}
          {userType === "company" && (
            <Row>
              <Col md={12} className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="eligibility"
                  label={t("profilePageTranslations.eligibilityLabel")}
                  checked={formData.eligibility || false}
                  onChange={(e) => onChange("eligibility", e.target.checked)}
                />
              </Col>
            </Row>
          )}
          {profileExists && (
            <ChangePasswordForm formData={formData} onChange={onChange} />
          )}

        </Form>
      </Card.Body>
    </Card>
  );
};
